import { useState } from 'react'

import { CommonSmallVerticalArrowRoundIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import Image from '@web/components/Image'

import { MissionCard, MissionCardProps } from '../MissionCard'
import styles from '../MissionCard.module.scss'
import Label from './Label'
import Reward from './Reward'

export interface NextStepPreviewProps {
  missionCard: MissionCardProps
  nClickArea?: {
    openPreview?: string
    closePreview?: string
  }
}

const NextStepPreview = ({ missionCard, nClickArea }: NextStepPreviewProps) => {
  const [showPreview, setShowPreview] = useState(false)
  const handleShowPreview = () => {
    setShowPreview(!showPreview)
  }

  const stepIndex = MissionCard.getCurrentStepIndex(missionCard) ?? 0

  const Preview = () => {
    return (
      <div className={styles.next_step_area}>
        {missionCard.missionCardGroup?.map((missionCard, index) => {
          if (index <= stepIndex) return null

          return (
            <div className={styles.next_step} key={missionCard.id}>
              {missionCard.label && <Label label={missionCard.label} />}
              {missionCard.previewText}
              <Reward {...missionCard.reward} />
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <>
      <div className={styles.next_btn_area}>
        <Clickable
          className={styles.btn}
          aria-haspopup="true"
          aria-expanded={showPreview}
          onClick={handleShowPreview}
          nClickCode={showPreview ? nClickArea?.closePreview : nClickArea?.openPreview}
        >
          {missionCard.nextStepPreview?.iconUrl && (
            <Image className={styles.icon_n} src={missionCard.nextStepPreview?.iconUrl} alt="" width={14} height={14} />
          )}
          {missionCard.nextStepPreview?.text}
          <CommonSmallVerticalArrowRoundIcon className={styles.icon} aria-hidden="true" />
        </Clickable>
      </div>
      {showPreview && <Preview />}
    </>
  )
}

export default NextStepPreview
